import React, {useEffect} from 'react'
import { observer } from "mobx-react-lite"
import Header from '../header/Header'
import classes from './ProducerSounds.module.scss'
import HomePacks from '../home/HomePacks'
import ShareCard from '../share/ShareCard'
import Footer from '../footer/Footer'
import useWindowSize from '../../hooks/window-size';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useTitle from '../../hooks/title'
import { scroll } from '../../utils'
import { useLocation } from "@reach/router"

const ProducerSounds = observer(() => {
  useTitle('Producer Sounds - Synth Samples, MIDI and Serum & Vital Presets');
  const windowSize = useWindowSize();
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  const nextPage = (e) => {
    const currentY = document.documentElement.scrollTop || document.body.scrollTop
    // window.scrollTo(0, windowSize.height)
    scroll(currentY, windowSize.height)
  }

  return <div className={classes.root}>
      {windowSize.width < 500 ? <Header /> : <Header normal/>}
      <section className={classes.banner}>
        <div className={classes.title}>
          Producer<br />Sounds
          <div className={classes.description}>
          Find your synth sound, download the sample or further tweak the MIDI in your favorite DAW
          </div>
        </div>
        <a className={classes.learnMore} onClick={nextPage}>Learn more
          <div className={classes.learnMoreArrows} onClick={nextPage}>
            <ExpandMoreIcon className={classes.learnMoreArrow1} />
            <ExpandMoreIcon />
          </div>
        </a>
      </section>
      <HomePacks catId={2}/>
      <ShareCard className={classes.share}/>
      <Footer />
    </div>;
})

export default ProducerSounds